/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const LeftArrowIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="28"
      viewBox="0 0 16 28"
      fill="none"
    >
      <path
        d="M6.18782 13.9412L15.2552 4.53333C15.7322 4.0354 16 3.36183 16 2.65973C16 1.95763 15.7322 1.28405 15.2552 0.786117C15.017 0.537024 14.7338 0.339313 14.4216 0.20439C14.1095 0.0694669 13.7747 2.40845e-06 13.4366 2.34932e-06C13.0984 2.2902e-06 12.7636 0.0694666 12.4515 0.204389C12.1394 0.339312 11.8561 0.537023 11.618 0.786116L0.757655 12.0543C0.517579 12.3014 0.327026 12.5953 0.196987 12.9192C0.0669487 13.243 -2.37622e-06 13.5904 -2.43756e-06 13.9412C-2.49891e-06 14.2921 0.0669485 14.6394 0.196987 14.9633C0.327026 15.2871 0.517578 15.5811 0.757654 15.8281L11.618 27.2293C11.8573 27.4756 12.1412 27.6704 12.4532 27.8027C12.7653 27.9349 13.0995 28.002 13.4366 28C13.7737 28.002 14.1078 27.9349 14.4199 27.8027C14.732 27.6704 15.0158 27.4756 15.2552 27.2293C15.7322 26.7313 16 26.0577 16 25.3556C16 24.6535 15.7322 23.98 15.2552 23.482L6.18782 13.9412Z"
        fill="#7E92A2"
      />
    </svg>
  )
}
